import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Login from './Pages/Login/Login';
import SignUp from './Pages/Sign Up/SignUp';
import GameRoom from './Pages/Discover/GameRoom';
import FriendsList from './Pages/Social/Friends';
import SettingsPage from './Pages/Account/Settings';
import WrappedPage from './Pages/Social/Wrapped';
import FeedPage from './Pages/Discover/FeedPage';
import Explore from './Pages/Discover/Explore.js';
import Notifications from './Pages/Social/Notifications.js'
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route, Outlet, Navigate, useNavigate } from 'react-router-dom'
import ProfilePage from './Pages/Social/Profile';

const BACKEND_ORIGIN = process.env.REACT_APP_BACKEND_ORIGIN;

const ProtectedRoute = () => {
  const navigate = useNavigate();
  const [verified, setVerified] = useState(false);
  React.useEffect(() => {
    const verify = async () => {
      const requestOptions = {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        credentials: "include"
      };
      const response = await fetch(`${BACKEND_ORIGIN}/verifytoken`, requestOptions);
      if (response.ok) {
        setVerified(true);
      }
      else {
        navigate("*");
      }
    }
    verify();
  }, [navigate]);
  if (!verified) {
    return <div>Blank page</div>
  }
  return <Outlet/>
}

const NoAuthRoute = () => {
  const navigate = useNavigate();
  React.useEffect(() => {
    const verify = async () => {
      const requestOptions = {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        credentials: "include"
      };
      try {
        const response = await fetch(`${BACKEND_ORIGIN}/verifytoken`, requestOptions);
        if (response.ok) {
          navigate("/app");
        }
        else {
          //console.log("Not authorized");
        }
      }
      catch (e) {

      }
    }
    verify();
  }, [navigate]);
  return <Outlet/>
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <title>POSTGAME</title>
    <Routes>
      <Route element={<NoAuthRoute/>}>
        <Route path="/*" element={<SignUp/>}/>
        <Route path="/login" element={<Login/>}/>
      </Route>
      <Route element={<ProtectedRoute/>}>
        <Route path="/app/*" element={<App/>}>
          <Route index element={<FeedPage/>}/>
          <Route path="game/*" element={<GameRoom/>}/>
          <Route path="game/:id" element={<GameRoom/>}/>
          <Route path="friends" element={<FriendsList/>}/>
          <Route path="profile" element={<ProfilePage/>}/>
          <Route path="profile/:id" element={<ProfilePage/>}/>
          <Route path="settings" element={<SettingsPage/>}/>
          <Route path="wrapped" element={<WrappedPage/>}/>
          <Route path="explore" element={<Explore/>}/>
          <Route path="notifications" element={<Notifications/>}/>
        </Route>
      </Route>
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
